import { useState } from 'react'
import { simulateUpload } from '@utils/index'
import ProgressBar from '@components/shared/ProgressBar'

const SimulatedUpload = () => {
    
    const [progress, setProgress] = useState(0)
    
    const onSimulateUploadClick = () => simulateUpload(100, setProgress, {
        minTimeout: 300,
        maxTimeout: 700,
    })
    
    return (
        
        <div>
            
            <h4>Simulated Upload</h4>
            
            <div className="flex gap-4 w-1/2">
                
                <button
                    className="btn btn-primary"
                    onClick={onSimulateUploadClick}>
                    Simulate Upload
                </button>
                
                <ProgressBar
                    className="ml-2 !w-[30rem]"
                    barClassName=""
                    max={100}
                    value={progress} />
            
            </div>
        
        </div>
        
    )
    
}

export default SimulatedUpload
